module.exports = __webpack_public_path__ + "static/media/fstatus-logo.9a271afa.svg";